// extracted by mini-css-extract-plugin
module.exports = {"root":"Notification_root__2TN1Y"};